export const brandsData = [
  {
    title: 'Tefal',
    link: 'https://tefal.ru/',
    image: '/images/brands/tefal.png',
    description:
      'официальный интернет-магазин бытовой техники и посуды | Доставка по всей России',
  },
  {
    title: 'Moulinex',
    link: 'https://moulinex.ru/',
    image: '/images/brands/moulinex.png',
    description: 'официальный интернет-магазин в России',
  },
  {
    title: 'Rowenta',
    link: 'https://rowenta.ru',
    image: '/images/brands/rowenta.png',
    description:
      'официальный интернет-магазин. Полный каталог товаров. Акции. Доставка по всей России. <br/>Продажа товаров Ровента по цене производителя | Москва',
  },
  {
    title: 'Krups',
    link: 'https://krups.ru',
    image: '/images/brands/krups.png',
    description:
      'официальный интернет-магазин в России | Автоматические и капсульные кофемашины',
  },

  {
    title: 'WMF',
    link: 'https://shop.wmfrussia.com',
    image: '/images/brands/WMF.png',
    description: 'официальный интернет-магазин в России',
  },
];
